import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { ProductConfigurationModelsAPIType } from "shared/types/ProductConfiguration"

export const productConfigurationModelsResponseTransformer =
  createResponseTransformer(json => {
    return {
      models: Array.isArray(json?.data)
        ? json.data.map(model =>
            serializer.deserialize(ProductConfigurationModelsAPIType, {
              data: model,
              included: json.included
            })
          )
        : []
    }
  })
